import {ErrorsPublishDraftValueObject} from './ErrorsPublishDraftValueObject.js'
import {RequestDraftValueObject} from './RequestDraftValueObject.js'
import {ResultPublishDraftValueObject} from './ResultPublishDraftValueObject.js'
import {SuccessResponseDraftValueObject} from './SuccessResponseDraftValueObject.js'
import {UploadResponseDraftValueObject} from './UploadResponseDraftValueObject.js'
import {UrlPublishDraftValueObject} from './UrlPublishDraftValueObject.js'

export class DraftValueObjectsFactory {
  /**
   * @method
   * @param {Object} draft
   * @return {DraftFormValueObject}
   */
  static successResponseDraftValueObject = () => new SuccessResponseDraftValueObject()

  static uploadResponseDraftValueObject = data => new UploadResponseDraftValueObject(data)

  static urlPublishDraftValueObject = ({code, url}) => new UrlPublishDraftValueObject({code, url})

  static errorsPublishDraftValueObject = data => new ErrorsPublishDraftValueObject(data)

  static requestDraftValueObject = ({
    adId,
    adTitle,
    bodyTypeIdWithDoors,
    carPlate,
    colourId,
    colourExtra,
    comments,
    email,
    environmentalLabel,
    fuelId,
    hidePhone,
    images,
    makeId,
    mileage,
    modelId,
    phone,
    plateRegistrationDate,
    price,
    provinceId,
    publishInVibbo,
    transmissionTypeId,
    userId,
    versionId,
    year,
    zipCode
  }) =>
    new RequestDraftValueObject({
      adId,
      adTitle,
      bodyTypeIdWithDoors,
      carPlate,
      colourId,
      colourExtra,
      comments,
      email,
      environmentalLabel,
      fuelId,
      hidePhone,
      images,
      makeId,
      mileage,
      modelId,
      phone,
      plateRegistrationDate,
      price,
      provinceId,
      publishInVibbo,
      transmissionTypeId,
      userId,
      versionId,
      year,
      zipCode
    })

  static resultPublishDraftValueObject = ({resultCode}) => new ResultPublishDraftValueObject({resultCode})
}
